import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    VTooltip,
    {
      attrs: { left: "" },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function (ref) {
            var on = ref.on
            return [
              _c(
                VBtn,
                _vm._g(
                  {
                    staticStyle: {
                      "border-radius": "50% !important",
                      border: "2px solid white",
                      "box-shadow": "0px 4px 4px rgba(0,0,0,0.25)",
                      "background-color": "#1C3754",
                    },
                    attrs: {
                      fab: "",
                      dark: "",
                      fixed: "",
                      right: "",
                      bottom: "",
                    },
                    on: { click: _vm.openTab },
                  },
                  on
                ),
                [
                  _c(
                    VIcon,
                    {
                      staticStyle: {
                        "margin-right": "0px !important",
                        transform: "scaleX(-1)",
                      },
                    },
                    [_vm._v(" mdi-message-processing-outline ")]
                  ),
                ],
                1
              ),
            ]
          },
        },
      ]),
    },
    [_c("span", [_vm._v("Servicio de soporte")])]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }